const routes = {
  HOME: '/',
  SIGN_IN: '/',
  SIGN_UP: '/sign-up',
  DASHBOARD: '/dashboard',
  CASES: '/cases',
  ACTIVITY: '/activity',
  CALENDAR: '/calendar',
  USERS: '/users',
  SURGEONS: '/surgeons',
  ADMIN: '/admin',
  PRODUCTS: '/products',
  PROCEDURES: '/procedures',
  DISTRIBUTORS: '/distributors',
  HOSPITALS: '/hospitals',
  MANUFACTURERS: '/manufacturers',
  LOGISTICS: '/logistics',
  TEAMS: '/engineering',
  COMPANIES: '/companies',
  RADIOLOGY: '/radiology',
  DOCUMENTS: '/documents',
};

export default routes;
